module.exports = "<app-go-back></app-go-back>\n<h3>{{ 'ERROR.ERROR_LABEL' | translate }}</h3>\n<p>{{ 'ERROR.PAGE_NOT_FOUND' | translate }}</p>\n"